import { ItemTypeMetadata } from "../../common-shared-module/model/dyn-form/form-metadata/item-type-metadata.enum";
import { ItemMetadata } from "../../common-shared-module/model/dyn-form/form-metadata/item/item-metadata.model";
import { MetadataFactory } from "../../common-shared-module/model/dyn-form/form-metadata/metadata.factory";
import { DDElement } from "./dd-element.model";


export class CustomMyTool implements DDElement {

    _id: string = "";

    constructor(protected myName: string, protected myLabel: string, protected myIcon: string) {
        this._id = "id" + Math.floor(Math.random() * 1000000);
    }

    removeDependencies(): ItemMetadata[] {
        return [this.item()]
    }

    id(): string {
        return this._id;
    }

    slotWeight(): number {
        return 1
    }

    label(): string {
        return this.myLabel
    }

    clone(): DDElement {
        return new CustomMyTool(this.myName, this.myLabel, this.myIcon)
    }

    icon(): string {
        return this.myIcon
    }

    name(): string {
        return this.myName
    }
    
    item(): ItemMetadata {
        return MetadataFactory.createItem(ItemTypeMetadata.Custom)
    }

}